// routes/_authenticated/documents/$type/index.tsx — legacy fallback only.
//
// ponytail: this route used to render every document detail page and read
// year/cnpj/reference_date/id_doc/versao from the search string. After
// the path-routing restructure, detail pages live one level deeper
// (`$type/$cnpj/$year/$referenceDate/$idDoc[/$versao]/`). We keep THIS
// file so users on pre-restructure bookmarks
// (`/documents/ipe?cnpj=…&reference_date=…&id_doc=…`) see the missing-key
// card with an explanation and a "back to dashboard" CTA instead of
// silently 404'ing through the file-based router.
import { createFileRoute, Link } from "@tanstack/react-router";

import { PageShell } from "@/components/page-shell";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute("/_authenticated/documents/$type/")({
  component: LegacyDocumentDetailFallback,
});

function LegacyDocumentDetailFallback() {
  return (
    <PageShell title="Documento" description="URL pre-restructure — apenas leitura." actions={null}>
      <MissingKeyCard />
    </PageShell>
  );
}

// ponytail: kept local because the path-based route doesn't need this copy.
// The path-based page renders a different "missing a path segment" card with
// copy that talks about path segments, not search params.
function MissingKeyCard() {
  return (
    <div
      className="flex flex-col items-center gap-3 rounded-md border border-dashed py-12 text-center"
      data-testid="document-legacy-fallback"
    >
      <div className="text-sm font-medium">Formato de URL desatualizado</div>
      <div className="text-muted-foreground max-w-md text-xs">
        Esta URL usa o formato antigo (<code>?cnpj=…&amp;reference_date=…&amp;id_doc=…</code>). Os
        novos links do dashboard usam uma URL canônica com CNPJ, ano, data de referência e
        identificador de entrega no caminho da rota, sem query string. Volte ao dashboard e clique
        em um filing recente para abrir a nova URL.
      </div>
      <Button asChild variant="outline" size="sm">
        <Link to="/dashboard">Voltar ao dashboard</Link>
      </Button>
    </div>
  );
}
